/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccAdvancedPatientDetails } from './PccAdvancedPatientDetails';
import {
    PccAdvancedPatientDetailsFromJSON,
    PccAdvancedPatientDetailsFromJSONTyped,
    PccAdvancedPatientDetailsToJSON,
    PccAdvancedPatientDetailsToJSONTyped,
} from './PccAdvancedPatientDetails';
import type { PccPatientDataUploadError } from './PccPatientDataUploadError';
import {
    PccPatientDataUploadErrorFromJSON,
    PccPatientDataUploadErrorFromJSONTyped,
    PccPatientDataUploadErrorToJSON,
    PccPatientDataUploadErrorToJSONTyped,
} from './PccPatientDataUploadError';

/**
 * 
 * @export
 * @interface CreatePccAdvancedPatientDetailsResponse
 */
export interface CreatePccAdvancedPatientDetailsResponse {
    /**
     * 
     */
    advanced_details?: PccAdvancedPatientDetails;
    /**
     * 
     */
    errors?: Array<PccPatientDataUploadError>;
}

/**
 * Check if a given object implements the CreatePccAdvancedPatientDetailsResponse interface.
 */
export function instanceOfCreatePccAdvancedPatientDetailsResponse(value: object): value is CreatePccAdvancedPatientDetailsResponse {
    return true;
}

export function CreatePccAdvancedPatientDetailsResponseFromJSON(json: any): CreatePccAdvancedPatientDetailsResponse {
    return CreatePccAdvancedPatientDetailsResponseFromJSONTyped(json, false);
}

export function CreatePccAdvancedPatientDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePccAdvancedPatientDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'advanced_details': json['advanced_details'] == null ? undefined : PccAdvancedPatientDetailsFromJSON(json['advanced_details']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(PccPatientDataUploadErrorFromJSON)),
    };
}

export function CreatePccAdvancedPatientDetailsResponseToJSON(json: any): CreatePccAdvancedPatientDetailsResponse {
    return CreatePccAdvancedPatientDetailsResponseToJSONTyped(json, false);
}

export function CreatePccAdvancedPatientDetailsResponseToJSONTyped(value?: CreatePccAdvancedPatientDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'advanced_details': PccAdvancedPatientDetailsToJSON(value['advanced_details']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(PccPatientDataUploadErrorToJSON)),
    };
}

